
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaito5jyotilingadarshancab() {



    const cardData =
    {
        keyword: 'Mumbai to 5 Jyotirlinga Darshan Cab Service',
        heading: 'Vedant Travels: Mumbai to 5 Jyotirlinga Darshan Cab Service',
        headingDescription: 'Vedant Travels offers a reliable and comfortable cab service for the Mumbai to 5 Jyotirlinga Darshan, ensuring a seamless pilgrimage experience. Our well-maintained fleet, including sedans, SUVs, and luxury cars, provides a safe and smooth journey for devotees. Our professional drivers are experienced with pilgrimage routes, making your spiritual journey hassle-free. With flexible pickup and drop-off options, 24/7 availability, competitive fares, and an easy online booking system, Vedant Travels ensures a divine and convenient travel experience.',

        top: 'Maharashtra 5 Jyotirlingas to Visit with Vedant Travels',

"topPlaces": [
    {
        "title": "Bhimashankar Jyotirlinga",
        "description": "Located in the Sahyadri Hills, Bhimashankar Jyotirlinga is one of the 12 sacred Jyotirlingas of Lord Shiva. Surrounded by dense forests and scenic landscapes, this temple is believed to be the site where Lord Shiva manifested as a Jyotirlinga after defeating the demon Bhima. The temple’s beautiful Nagara-style architecture and the nearby Bhimashankar Wildlife Sanctuary make it a must-visit spiritual and natural retreat."
    },
    {
        "title": "Trimbakeshwar Jyotirlinga",
        "description": "Situated in Trimbak, Nashik, the Trimbakeshwar Temple is unique as it houses three lingams representing Brahma, Vishnu, and Mahesh (Shiva). It is located near the origin of the sacred Godavari River and is an important site for rituals like Narayan Nagbali and Kalsarpa Puja. The temple’s serene environment and historic significance attract thousands of devotees every year."
    },
    {
        "title": "Grishneshwar Jyotirlinga",
        "description": "Located near Ellora Caves, Grishneshwar Jyotirlinga is considered the last of the 12 Jyotirlingas. This temple is an architectural marvel, featuring intricate carvings and a five-tiered shikhara. Devotees believe that a visit to Grishneshwar Temple blesses them with spiritual enlightenment and prosperity. The temple is just a short distance from Ajanta and Ellora caves, making it a significant cultural and religious destination."
    },
    {
        "title": "Aundha Nagnath Jyotirlinga",
        "description": "Situated in Hingoli district, Maharashtra, Aundha Nagnath Jyotirlinga is one of the most ancient Shiva temples, dating back to the Pandava era. The temple is associated with Shri Eknath Maharaj, a famous saint, and is believed to be the first Jyotirlinga where Lord Shiva is worshiped as 'Nagnath' (Lord of Serpents). The grand temple architecture and its peaceful surroundings make it a must-visit for devotees."
    },
    {
        "title": "Parli Vaijnath Jyotirlinga",
        "description": "Located in Beed district, Maharashtra, Parli Vaijnath Jyotirlinga is believed to grant moksha (liberation) and good health. Devotees visit this temple to seek blessings for healing and well-being. The temple’s rich history and Hemadpanthi-style architecture add to its spiritual charm. The temple is easily accessible and a significant pilgrimage site in Maharashtra."
    }
],

"services": [
    {
        "name": "Mumbai to 5 Jyotirlinga Darshan Cab",
        "description": "Embark on a spiritual journey with Vedant Travels. We offer comfortable and reliable cab services for your 5 Jyotirlinga darshan from Mumbai. Our experienced drivers and well-maintained vehicles ensure a smooth and memorable pilgrimage to the sacred Jyotirlinga temples."
    },
    {
        "name": "Jyotirlinga Tour from Mumbai",
        "description": "Plan your Jyotirlinga tour from Mumbai with Vedant Travels. We provide comfortable and efficient travel services to visit all the sacred Jyotirlinga temples. Whether it’s a one-way trip or a round trip, our fleet of vehicles is ready to accommodate your journey."
    },
    {
        "name": "Mumbai to Jyotirlinga Temple Taxi",
        "description": "Travel in comfort to the Jyotirlinga temples from Mumbai with Vedant Travels. Our fleet of vehicles includes a range of options to suit your preferences, ensuring a smooth and peaceful journey to these sacred sites."
    },
    {
        "name": "5 Jyotirlinga Darshan Taxi Booking",
        "description": "Booking a taxi for your 5 Jyotirlinga darshan from Mumbai is simple with Vedant Travels. We provide easy booking options online or via phone. Choose from our fleet of vehicles for a comfortable and convenient experience throughout your pilgrimage."
    },
    {
        "name": "Mumbai to Jyotirlinga Cab Fare",
        "description": "At Vedant Travels, we offer transparent and competitive pricing for your journey to the Jyotirlinga temples. Whether you're going for a one-way trip or a round trip, our pricing is designed to be affordable, with no hidden charges. Contact us for an accurate fare estimate based on your trip details."
    },
    {
        "name": "5 Jyotirlinga Darshan One Way Taxi",
        "description": "If you're looking for a one-way taxi from Mumbai to visit the 5 Jyotirlinga temples, Vedant Travels offers convenient one-way cab services. Our professional drivers ensure a smooth journey to all the temples for a hassle-free darshan."
    },
    {
        "name": "Mumbai to Jyotirlinga Car Rental",
        "description": "Rent a car for your Jyotirlinga tour from Mumbai with Vedant Travels. We offer flexible car rental options with a variety of vehicles, ensuring you travel in comfort and style. Our experienced drivers are ready to guide you on your spiritual journey."
    },
    {
        "name": "Mumbai to Jyotirlinga Innova",
        "description": "For a comfortable and luxurious travel experience, book an Innova for your Mumbai to Jyotirlinga journey. Spacious, comfortable, and perfect for family or group travel, the Innova is ideal for your pilgrimage to the sacred Jyotirlinga temples."
    },
    {
        "name": "Mumbai to Jyotirlinga Round Trip",
        "description": "Vedant Travels offers convenient round-trip services from Mumbai to the Jyotirlinga temples. Enjoy a seamless and stress-free journey with our experienced drivers, who know the best routes to make your pilgrimage both smooth and memorable."
    },
    {
        "name": "Jyotirlinga Tour by Cab from Mumbai",
        "description": "Take a spiritual journey with Vedant Travels on our Jyotirlinga tour by cab from Mumbai. Our comfortable and reliable cabs will take you to all the sacred Jyotirlinga temples, offering flexibility in your travel schedule to make your darshan experience truly special."
    }
],

"tableData": [
    ["Mumbai to 5 Jyotirlinga Darshan Cab", "Jyotirlinga Tour from Mumbai"],
    ["Mumbai to Jyotirlinga Temple Taxi", "5 Jyotirlinga Darshan Taxi Booking"],
    ["Mumbai to Jyotirlinga Cab Fare", "5 Jyotirlinga Darshan One Way Taxi"],
    ["Mumbai to Jyotirlinga Car Rental", "Mumbai to Jyotirlinga Innova"],
    ["Mumbai to Jyotirlinga Round Trip", "Jyotirlinga Tour by Cab from Mumbai"],
    ["", ""]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the importance of punctuality. Our experienced drivers ensure timely pickups and drop-offs for your 5 Jyotirlinga darshan, allowing you to have a smooth and spiritual journey."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "We offer a range of comfortable and spacious vehicles for your Jyotirlinga pilgrimage. Our vehicles are well-maintained, with ample legroom and air conditioning, ensuring a pleasant and relaxing journey throughout."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and familiar with the best routes for your journey to the Jyotirlinga temples. They prioritize your comfort and safety, making your trip smooth and stress-free."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers transparent and competitive pricing for your Jyotirlinga darshan. There are no hidden charges, and our pricing is clear and upfront, ensuring you get the best value for your spiritual journey."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our top priority. Our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols, ensuring a secure journey for you and your family."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you're planning a morning or night journey, Vedant Travels is available 24/7. Our customer service team is always ready to assist with your bookings and any inquiries, ensuring you're always covered."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Jyotirlinga darshan cab is easy with Vedant Travels. You can book your ride online through our website or app, or contact our customer service team for assistance. We make the booking process simple and convenient."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer customizable travel packages for your Jyotirlinga tour. Whether you need a one-way trip, round trip, or a specific schedule, we will tailor the journey to suit your needs and preferences."
    }
  ]



    }
   const faqData = [
    {
        id: 1,
        question: 'How can I book a Mumbai to 5 Jyotirlinga Darshan cab with Vedant Travels?',
        answer: 'You can easily book your cab online through our website or mobile app. Alternatively, our customer service team is available to assist you over the phone.',
    },
    {
        id: 2,
        question: 'Are the drivers experienced for long-distance travel?',
        answer: 'Yes, our drivers are highly experienced and familiar with the routes to the 5 Jyotirlinga temples. They ensure your journey is smooth, safe, and efficient.',
    },
    {
        id: 3,
        question: 'What types of vehicles are available for Mumbai to 5 Jyotirlinga Darshan travel?',
        answer: 'We offer a range of well-maintained vehicles, including sedans, SUVs, and luxury cars. All our vehicles are designed for comfort during long-distance journeys.',
    },
    {
        id: 4,
        question: 'How do I pay for my Mumbai to 5 Jyotirlinga Darshan cab rental?',
        answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payment via our app for your convenience.',
    },
    {
        id: 5,
        question: 'Can I book a round trip for the 5 Jyotirlinga Darshan tour?',
        answer: 'Yes, you can book a round trip. Simply provide your return details when booking, and we will ensure a smooth and comfortable return journey after your darshan.',
    },
    {
        id: 6,
        question: 'Are there any extra charges for waiting or detours?',
        answer: 'Any additional charges for waiting or detours will be communicated clearly upfront. We are committed to complete transparency in pricing.',
    },
    {
        id: 7,
        question: 'Can I hire a cab for sightseeing in and around the Jyotirlinga temples?',
        answer: 'Yes, we offer sightseeing services as part of your 5 Jyotirlinga Darshan tour. Visit the temples and nearby attractions with a trusted and knowledgeable driver guiding you throughout.',
    },
    {
        id: 8,
        question: 'What is the luggage allowance for a Mumbai to 5 Jyotirlinga Darshan cab?',
        answer: 'Our vehicles can comfortably accommodate standard luggage. If you have larger or specialized luggage, please let us know when booking, and we will make the necessary arrangements.',
    },
    {
        id: 9,
        question: 'Is Vedant Travels available for corporate travel to the Jyotirlingas?',
        answer: 'Yes, we offer tailored corporate travel services for employees, teams, or groups visiting the 5 Jyotirlinga temples. We can accommodate your business needs, providing a comfortable and professional travel experience.',
    },
    {
        id: 10,
        question: 'Why should I choose Vedant Travels for Mumbai to 5 Jyotirlinga Darshan?',
        answer: 'Vedant Travels offers a reliable, safe, and affordable service for your 5 Jyotirlinga Darshan tour. With experienced drivers, comfortable vehicles, and transparent pricing, we ensure that your spiritual journey is smooth, safe, and memorable.',
    },
];

const testimonials = [
    {
        name: "Mr. Harish Desai",
        title: "Family Traveler",
        quote: "Our family booked a Mumbai to 5 Jyotirlinga Darshan trip with Vedant Travels. The journey was well-planned, the vehicle was comfortable, and the driver was very professional. We had a wonderful experience and highly recommend them!",
        rating: 5,
    },
    {
        name: "Mrs. Priya Reddy",
        title: "Spiritual Traveler",
        quote: "I booked a cab for a spiritual tour of the 5 Jyotirlingas, and the experience was fantastic. The driver was courteous, the car was clean and comfortable, and we had a peaceful and timely trip. Highly recommend Vedant Travels for religious tours!",
        rating: 5,
    },
];

    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
 
  
  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to 5 Jyotirlinga Darshan Cab",
  "image": "https://vedanttravels.in/assets/images/mumbai-to-5-jyotirlinga-darshan-cab.jpg",
  "description": "Book Mumbai to 5 Jyotirlinga Darshan cab with Vedant Travels for a spiritual and comfortable pilgrimage journey. AC sedans, SUVs, and tempo travellers available for one-way and round trips to the holy Jyotirlinga shrines.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6999",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-to-5-jyotirlinga-darshan-cab"
  }
};


   
      


    return (
        <div>
           
          <Helmet>
  <title>Mumbai to 5 Jyotirlinga Darshan Cab | Spiritual Pilgrimage Ride | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai to 5 Jyotirlinga Darshan cab with Vedant Travels for a spiritual and comfortable pilgrimage journey. AC sedans, SUVs, and tempo travellers available for one-way and round trips to the holy Jyotirlinga shrines." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to 5 Jyotirlinga Darshan Cab, Jyotirlinga Pilgrimage Cab Mumbai, Mumbai to Jyotirlinga Taxi, Vedant Travels Mumbai Jyotirlinga, Spiritual Cab Booking Mumbai, One Way Jyotirlinga Cab Mumbai, Comfortable Pilgrimage Cab Mumbai, AC Cab Mumbai to Jyotirlinga, Mumbai to Jyotirlinga Outstation Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

  
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/81.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaito5jyotilingadarshancab;